
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import AnimationFactory from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameStatus from "../model/GameStatus";
import SaveModel from "../model/SaveModel";
import AbstractAccuracyScreenMediator from "./AbstractAccuracyScreenMediator";
import BottomHudView from "./BottomHudView";
import GameElementSkinFactory from "./GameElementSkinFactory";
import HudView from "./HudView";
import PuzzleView from "./PuzzleView";

export default class GameScreenMediator extends AbstractAccuracyScreenMediator {

    /**
     * @param {*} target 
     * @param {*} dispatcher 
     * @param {*} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {GameModel} gameModel 
     * @param {GameConfig} gameConfig 
     * @param {RoadBuilder} roadBuilder 
     * @param {Object} roadAssets 
     * @param {SaveModel} saveModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, gameConfig, saveModel, gameAssets, levelAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets);
        this._gameConfig = gameConfig;
        this._levelAssets = levelAssets;

        this._handleTickBound = this._handleTick.bind(this);
        this._handleGameModelStatusBound = this._handleGameModelStatus.bind(this);
        this._handleGameModelPuzzleBound = this._handleGameModelPuzzle.bind(this);
        this._handleGameModelScoreBound = this._handleGameModelScore.bind(this);
        this._handleGameModelMistakesBound = this._handleGameModelMistakes.bind(this);
        this._handleGameModelElapsedTimeBound = this._handleGameModelElapsedTime.bind(this);
        this._handlePuzzleItemSelectBound = this._handlePuzzleItemSelect.bind(this);
    }

    initialize() {
        super.initialize();

        this.anchorObject(this._target.hud, Anchor.T);

        this._elementFactory = new GameElementSkinFactory(this._gameConfig, this._levelAssets);
        this._levelPlaceholder = this._target.level;
        this._levelPlaceholder.removeAllChildren();

        this._hud = new HudView(this._target.hud, this._languagePack);
        this._hudBottom = new BottomHudView(this._target.hudBottom, this._languagePack);

        this._hudBottom.addEventListener(BottomHudView.SUBMIT, this._handleSubmitClick.bind(this));
        this._hudBottom.enableSubmit(false);

        this._initializeDebug();

        this._addEventListeners();

        const saveGame = this._saveModel.getSaveGame();
        this._reset(saveGame);

        // if (!saveGame && getURLParameter("skiptutorial") != "1") {
        //     this._startTutorial();
        // } else {
        //     const delay = this.checkSavegameRestoredFeedback(500) ? 1500 : 0;
        //     this.callDelayed(this._handleTutorialClose.bind(this), delay);
        // }

        if (!saveGame && getURLParameter("skiptutorial") != "1") {
            this._startTutorial();
        } else {
            this._startGame();
        }
    }

    destroy() {
        super.destroy();
        this._removeEventListeners();
        if (window.gamescreen == this) {
            window.gamescreen = null;
        }
    }

    _addEventListeners() {
        this._gameModel.addEventListener(GameModel.STATUS, this._handleGameModelStatusBound);
        this._gameModel.addEventListener(GameModel.PUZZLE, this._handleGameModelPuzzleBound);
        this._gameModel.addEventListener(GameModel.SCORE, this._handleGameModelScoreBound);
        this._gameModel.addEventListener(GameModel.MISTAKES, this._handleGameModelMistakesBound);
        this._gameModel.addEventListener(GameModel.ELAPSED_TIME, this._handleGameModelElapsedTimeBound);
    }
    _removeEventListeners() {
        this._gameModel.removeEventListener(GameModel.STATUS, this._handleGameModelStatusBound);
        this._gameModel.removeEventListener(GameModel.PUZZLE, this._handleGameModelPuzzleBound);
        this._gameModel.removeEventListener(GameModel.SCORE, this._handleGameModelScoreBound);
        this._gameModel.removeEventListener(GameModel.MISTAKES, this._handleGameModelMistakesBound);
        this._gameModel.removeEventListener(GameModel.ELAPSED_TIME, this._handleGameModelElapsedTimeBound);
    }

    _handleGameModelPuzzle() {
        this._doPuzzleTransition();
    }

    _handleGameModelScore() {
        this._hud.setScore(this._gameModel.score);
    }
    _handleGameModelMistakes() {
        this._hud.setMistakes(this._gameModel.mistakeCount);
    }

    _handleGameModelStatus({ data: status }) {
        switch (status) {
            case GameStatus.TIMEOUT:
                this._stopTicker();
                this.showPopupForPrefix("game.timeout", _ => this.gotoScreen(SkinKeys.END_SCREEN));
                break;
            case GameStatus.END:
                this._stopTicker();
                this.gotoScreen(SkinKeys.END_SCREEN);
                break;
        }
    }

    _handleGameModelElapsedTime() {
        this._hud.setTime(this._gameModel.remainingTime);
    }


    _reset(snapshot) {
        this._stopTicker();
        // if (snapshot && snapshot.status == GameStatus.RUNNING) {
        //     this._gameModel.applySnapshot(snapshot, true);
        // } else {
        this._gameModel.reset();
        // }
    }

    _startTicker() {
        this._tickTime = performance.now();
        this._target.stage.addEventListener("tick", this._handleTickBound);
    }
    _stopTicker() {
        this._target.stage.removeEventListener("tick", this._handleTickBound);
    }
    _handleTick() {
        if (!this._paused) {
            const now = performance.now();
            const delta = now - this._tickTime;
            this._tickTime = now;
            this._gameModel.step(delta);
        }
    }


    _startGame() {
        this._doNextPuzzle();
        this._gameModel.start();
        this.callDelayed(this._startTicker.bind(this), 1000);
    }

    _doNextPuzzle() {
        // if (this._gameModel.hasNextPuzzle()) {
            this._gameModel.doNextPuzzle();
        // } else {
        //     this.gotoScreen(SkinKeys.END_SCREEN);
        // }
    }

    _doPuzzleTransition() {
        const cross = this._puzzleView != null;
        const puzzleModel = this._gameModel.puzzle;
        const sampleSkin = this._elementFactory.getItem(puzzleModel.target);
        this._hudBottom.enableSubmit(false);
        const animateIn = _ => {
            const target = this._levelPlaceholder.addChild(new createjs.Container());
            this._puzzleView = new PuzzleView(target, puzzleModel, this._elementFactory, this._layoutManager);
            this._puzzleView.animateIn(300, 700, onAnimateInComplete);
        }
        const onAnimateInComplete = _ => {
            this._puzzleView.addEventListener(PuzzleView.SELECT, this._handlePuzzleItemSelectBound);
            this._puzzleView.enabled = true;
            this._hudBottom.enableSubmit(true);
            if (this._gameModel.puzzleIndex == 0) {
                // this._puzzleView.doDragNudge();
                this.callDelayed(_ => { this._puzzleView.doDragNudge(); }, 300);
            }
        }
        if (cross) {
            this._puzzleView.enabled = false;
            this._puzzleView.animateOut(300, 0, _ => { 
                this._destroyPuzzleView(this._puzzleView); 
                animateIn();
            });
            this._hudBottom.crossFadeSample(sampleSkin, 400, 300);
        } else {
            animateIn();
            this._hudBottom.setSample(sampleSkin);
        }
    }

    _destroyPuzzleView(puzzleView = null) {
        if (puzzleView) {
            this._levelPlaceholder.removeChild(puzzleView.target);
            puzzleView.destroy();
        }
    }


    /*******************************
     *     PUZZLE INTERACTION
     *******************************/


    _handleSubmitClick() {
        if (getURLParameter("confirm") != "1") {
            this._submitPuzzle();
        } else {
            this.showPopupForPrefix("game.confirmSubmit", this._submitPuzzle.bind(this));
        }
    }

    _submitPuzzle() {
        this._gameModel.submitPuzzle();
        this._doNextPuzzle();
    }

    _handlePuzzleItemSelect({data:slotIndex}) {
        this._gameModel.selectItem(slotIndex);
    }

    /********************
     *     GENERIC
     ********************/

    showPopupForPrefix(prefix, callbackOk, callbackCancel) {
        const title = this.getText(`${prefix}.title`);
        const body = this.getText(`${prefix}.body`);
        const buttonParams = [];
        const ok = this.getText(`${prefix}.ok`);
        if (ok) {
            buttonParams.push({ label: ok, callback: callbackOk });
        }
        const cancel = this.getText(`${prefix}.cancel`);
        if (cancel) {
            buttonParams.push({ label: cancel, callback: callbackCancel });
        }

        this.showPopup(title, body, buttonParams);
    }


    /********************
     *     TUTORIAL
     ********************/

    _startTutorial() {
        this._gameModel.initTutorialPuzzle();
        const delay = this._gameConfig.getValue("tutorial.delay");
        const duration = this._gameConfig.getValue("tutorial.fadeDuration");
        const callback = _ => {            
            this._hud.setScore(17);
            this._hud.setMistakes(6);
            this._hudBottom.enableSubmit(true);
        }
        const options = new AnimationOptions(delay, duration, createjs.Ease.quadIn, [callback]);
        this.openPopup(SkinKeys.TUTORIAL_OVERLAY_SKIN, this._handleTutorialClose.bind(this), AnimationFactory.FADE_IN, options);
    }

    _handleTutorialClose() {
        this._hud.setScore(0);
        this._hud.setMistakes(0);
        this.callDelayed(this._startGame.bind(this), 1000);
    }



    /********************
     *     DEBUG
     ********************/

    _initializeDebug() {
        if (ranj.DEBUG) {
            window.document.addEventListener('keyup', e => {
                const c = String.fromCharCode(e.which);
                //console.log(c, e.code, e.which);
                if (c == "P") {
                    this._paused = !this._paused;
                    if (!this._paused) {
                        this._tickTime = performance.now();
                    }
                } else if (c == "E") {
                    this.gotoScreen(SkinKeys.END_SCREEN);
                } else if (c == "T") {
                    this._gameModel.step(this._gameModel.remainingTime - 1000);
                } else if (c == "C") { //reset puzzle
                    this._gameModel._puzzleIndex--;
                    this._doNextPuzzle();
                } else if (c == "D") {
                    this._puzzleView.doDragNudge();
                } else if (c == "1") {
                    this._gameModel._puzzleIndex = -1;
                    this._doNextPuzzle();
                } else if (e.which == 37) {
                    this._gameModel._puzzleIndex = Math.max(-1, this._gameModel._puzzleIndex - 2);
                    this._doNextPuzzle();
                } else if (e.which == 39) {
                    this._gameModel.doNextPuzzle();
                }
            });
            window.gamescreen = this;//for console access
        }
    }

}
